import { Box, Grid } from '@material-ui/core';
import { X, XOctagon } from 'react-feather';
import { useStyles } from '../PersonValidationAlert/PersonValidationAlert';

type Props = {
  showValidationDimexAlert: boolean;
  onCloseValidationDimexAlert: () => void;
};

const PersonValidationDIMEXAlert = ({
  onCloseValidationDimexAlert,
  showValidationDimexAlert,
}: Props): JSX.Element => {
  const classes = useStyles();

  if (!showValidationDimexAlert) {
    return <div data-testid="empty-validation-dimex-message" />;
  }

  return (
    <Grid
      container
      className={classes.container}
      data-testid="full-validation-dimex-message"
    >
      <Box display="flex" sx={{ width: '100%' }}>
        <Box sx={{ width: 26, marginRight: 10 }}>
          <Box>
            <XOctagon color="#B80016" />
          </Box>
        </Box>
        <Box flexGrow={1} className={classes.text}>
          Ingrese un número de
          <Box
            component="span"
            sx={{
              display: { xs: 'block', sm: 'inline' },
            }}
          >
            {' '}
            identificación DIMEX válido
          </Box>
        </Box>
        <Box sx={{ width: 26 }}>
          <Box className={classes.close}>
            <X
              data-testid="close-validation-dimex-icon"
              color="#B80016"
              onClick={onCloseValidationDimexAlert}
            />
          </Box>
        </Box>
      </Box>
    </Grid>
  );
};

export default PersonValidationDIMEXAlert;
